import styled from "styled-components";
import { Button } from "antd";

const StyledButton = styled(Button)`
    color: ${({ theme }) => theme.colors.primary};
    width: 36%;
    min-width: 120px;
    max-width: 200px;
    height: 40px;
    border: none;
    font-weight: 700;
    border-radius: 8px;
    text-transform: uppercase;
    font-size: 18px;
    border: 1px solid ${({ theme }) => theme.colors.primary};
    &:focus,
    &:hover {
        color: ${({ theme }) => theme.colors.primary};
    }
    &:active {
        color: ${({ theme }) => theme.colors.primary};
    }
`;

export default StyledButton;
